import apiClient from "@/shared/api/apiClient2";

export const getViewingTransaction = async (id) => {
  try {
    const { data } = await apiClient.get(`/viewing/transaction/${id}`);
    return data;
  } catch (e) {
    console.error("[transaction/public] getViewingTransaction", e);
  }
};
